import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const TODAY = () => {
  return (
    <CardSection id="TODAY" title="TODAY">
      <Paragraph>현재 날짜를 반환하며 시간은 포함되지 않습니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>TODAY()</Paragraph>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>TODAY()</Paragraph>
        <Img src="computeToday" />
      </ListSection>
    </CardSection>
  );
};
